module.exports = __webpack_public_path__ + "img/game_fields.389cf86f.svg";